import {
  AlertTriangle,
  ArrowLeftRight,
  BarChart3,
  Bell,
  ClipboardList,
  FileText,
  ShieldCheck,
} from "lucide-react";
import { isDesktopNotificationEnabled } from "./notificationDesktop";

export const NOTIFICATION_CATEGORIES = {
  dsar: {
    label: "DSAR Records",
    Icon: FileText,
    color: "text-blue-600",
    bg: "bg-blue-50",
    ring: "ring-blue-100",
    gradient: "from-blue-500 to-indigo-600",
  },
  consent_variance: {
    label: "Consent Variance",
    Icon: ArrowLeftRight,
    color: "text-violet-600",
    bg: "bg-violet-50",
    ring: "ring-violet-100",
    gradient: "from-violet-500 to-purple-600",
  },
  breach: {
    label: "Breach Incidents",
    Icon: AlertTriangle,
    color: "text-red-600",
    bg: "bg-red-50",
    ring: "ring-red-100",
    gradient: "from-red-500 to-rose-600",
  },
  assessment: {
    label: "Assessment",
    Icon: ShieldCheck,
    color: "text-emerald-600",
    bg: "bg-emerald-50",
    ring: "ring-emerald-100",
    gradient: "from-emerald-500 to-teal-600",
  },
  form_questions: {
    label: "Form Questions",
    Icon: ClipboardList,
    color: "text-indigo-600",
    bg: "bg-indigo-50",
    ring: "ring-indigo-100",
    gradient: "from-indigo-500 to-violet-600",
  },
  stats: {
    label: "Widget Stats",
    Icon: BarChart3,
    color: "text-sky-600",
    bg: "bg-sky-50",
    ring: "ring-sky-100",
    gradient: "from-sky-500 to-cyan-600",
  },
};

export function getNotificationCategoryMeta(category) {
  return (
    NOTIFICATION_CATEGORIES[category] || {
      label: "Notification",
      Icon: Bell,
      color: "text-slate-600",
      bg: "bg-slate-50",
      ring: "ring-slate-100",
      gradient: "from-slate-500 to-slate-700",
    }
  );
}

export function parseNotificationMessage(message) {
  if (!message) return { lead: "", body: "", byline: "" };
  const parts = message.split(" — ").map((p) => p.trim()).filter(Boolean);
  if (parts.length >= 3) {
    return {
      lead: parts[0],
      body: parts.slice(1, -1).join(" — "),
      byline: parts[parts.length - 1],
    };
  }
  if (parts.length === 2) {
    return { lead: parts[0], body: "", byline: parts[1] };
  }
  return { lead: "", body: message, byline: "" };
}

export function formatNotificationDate(dateStr) {
  if (!dateStr) return "";
  try {
    const date = new Date(dateStr);
    return date.toLocaleString(undefined, {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  } catch {
    return "";
  }
}

export function showDesktopNotification(title, body = "", { silent = true } = {}) {
  if (!isDesktopNotificationEnabled()) return;
  try {
    const notification = new Notification(title || "New notification", {
      body: String(body || "").slice(0, 180),
      silent,
      tag: "onedpdp-inbox",
      icon: "/OneDPDP_Icon.png",
    });
    window.setTimeout(() => notification.close(), 7000);
  } catch {
    /* ignore unsupported or autoplay-blocked desktop notifications */
  }
}

export function relatedActionLabel(actionUrl) {
  if (!actionUrl) return null;
  const map = {
    "/user/gap-assessment": "Open Gap Assessment",
    "/tenant/gap-assessment": "Open Gap Assessment Admin",
    "/user/pia": "Open PIA Form",
    "/user/ropa": "Open ROPA Form",
    "/user/tprm": "Open TPRM Questionnaire",
    "/user/breach-management": "Open Breach Management",
    "/user/dsar": "Open DSAR Records",
    "/user/consent-variance": "Open Consent Variance",
  };
  if (map[actionUrl]) return map[actionUrl];
  if (actionUrl.includes("/tenant/form-questions")) return "Open Form Questions Manager";
  if (actionUrl.startsWith("/tenant")) return "Open in Admin Panel";
  if (actionUrl.startsWith("/user")) return "Open Related Page";
  return "Open Related Page";
}
